import { render } from "./login-button.vue?vue&type=template&id=2c2e5d4d&scoped=true"
import script from "./login-button.vue?vue&type=script&lang=js"
export * from "./login-button.vue?vue&type=script&lang=js"

import "./login-button.vue?vue&type=style&index=0&id=2c2e5d4d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2e5d4d"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
